module.exports = '<svg width="43" height="32" viewBox="0 0 43 32"><path d="M40 26.667H28.472L18.795 2.478C18.248 1.11 16.611.001 15.139.001H2.667C1.192.001 0 1.193 0 2.668s1.192 2.667 2.667 2.667h11.528l9.677 24.189c.547 1.368 2.184 2.477 3.656 2.477H40c1.475 0 2.667-1.192 2.667-2.667S41.475 26.667 40 26.667zM26.667 5.333H40c1.475 0 2.667-1.192 2.667-2.667S41.475-.001 40-.001H26.667C25.192-.001 24 1.191 24 2.666s1.192 2.667 2.667 2.667z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/option-1.js
// module id = 1322
// module chunks = 14